/**
 * Mapping of Qmkey API returned fields to the frontend's QUnitField
 **/

import QFields from './QFields';

/**
 * Table to translate from backend API to frontend.
 **/
export const API_TO_QFIELD = {
  fallback: 'QUnitFieldFallback',
  BPDateTimeField: 'QUnitFieldDateTime',
  BPDateField: 'QUnitFieldDate',
  BPImageField: 'QUnitFieldImage',
  BPLinkField: 'QUnitFieldLink',
  BPFileField: 'QUnitFieldFile',
  BPNumericField: 'QUnitFieldNumeric',
  BPTextareaField: 'QUnitFieldStringArea',
  BPAutocompleteChoiceField: 'QUnitFieldRelation',
  BPTreeviewChoiceField: 'QUnitFieldRelation',
  BPChoiceField: 'QUnitFieldRelation',
  BPDirectoryField: 'QUnitFieldRelation',
  BPTextField: 'QUnitFieldString',
  BPDecimalField: 'QUnitFieldDecimal',
  BPUserField: 'QUnitFieldUser',
  BPRelated: 'QUnitFieldRelation', // TODO
  BPRelationshipsField: 'QUnitFieldRelationLink',
  BPProcessDependingUserField: 'QUnitFieldUser', // TODO
  BPDynamicChoiceField: 'QUnitFieldRelation', // TODO
  BPTagField: 'QUnitFieldString',
  BPTimeEventField: 'QUnitFieldTimeEvent',
  BPStateField: 'QUnitFieldState',
  BPDateLimitField: 'QUnitFieldDate',
  BPVersionableFileField: "QUnitVersionableFieldFile",
  BPIndicatorTrackingField: "QUnitFieldIndicatorTracking",
  BPCentroField: 'QUnitFieldCentro',
  BPIndicatorRiskInterpretationField: 'QUnitFieldIndicatorRiskInterpretation',
};

// Automatic reverse map
let QFIELD_TO_API = {};
for (const [key, value] of Object.entries(API_TO_QFIELD))
  QFIELD_TO_API[value] = key;

// Module functions
export default {
  apitype2field(type) {
    /** type is an string
     * Returns an instanciable object
     * Usage example:
     *   qfield_type = api2field(type)
     *   field = qfield_type(value)
     **/
    const res = QFields[API_TO_QFIELD[type] || API_TO_QFIELD.fallback];
    if (res === undefined)
      throw `Programming error in fields_mapping: Incorrect mapping for "${type}"`;
    return res;
  },

  field2apitype(field) {
    // field is an instance of QUnitField*
    // Returns an string for the API types
    const name = field.constructor.name;
    return QFIELD_TO_API[name];
  },
};
